import React from 'react';
import { motion } from 'framer-motion';
import { Target, Calculator, Cpu, BarChart3, Factory, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PersonaNavigation = ({ currentPersona }) => {
  const personas = [
    { 
      id: 'managing-directors',
      title: 'Managing Directors', 
      icon: Target, 
      path: '/sap-business-one/for/managing-directors', 
      color: 'from-blue-500 to-sky-500',
      tagline: 'Strategic growth insights'
    },
    { 
      id: 'finance-directors',
      title: 'Finance Directors', 
      icon: Calculator, 
      path: '/sap-business-one/for/finance-directors', 
      color: 'from-green-500 to-emerald-500',
      tagline: 'Control & compliance'
    },
    { 
      id: 'it-directors',
      title: 'IT Directors', 
      icon: Cpu, 
      path: '/sap-business-one/for/it-directors', 
      color: 'from-purple-500 to-indigo-500',
      tagline: 'Fast deployment'
    },
    { 
      id: 'operations-directors',
      title: 'Operations Directors', 
      icon: BarChart3, 
      path: '/sap-business-one/for/operations-directors', 
      color: 'from-orange-500 to-amber-500',
      tagline: 'Streamline processes'
    },
    { 
      id: 'manufacturing-directors',
      title: 'Manufacturing Directors', 
      icon: Factory, 
      path: '/sap-business-one/for/manufacturing-directors', 
      color: 'from-slate-600 to-blue-700',
      tagline: 'Shop floor control'
    }
  ];

  // Filter out current persona
  const otherPersonas = personas.filter(p => p.id !== currentPersona);

  return (
    <section className="py-12 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-8">
          <h3 className="text-xl font-bold text-gray-900 mb-2">Explore Solutions for Other Business Leaders</h3>
          <p className="text-gray-600">See how SAP Business One empowers different roles</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {otherPersonas.map((persona, idx) => (
            <Link key={persona.id} to={persona.path}>
              <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.3, delay: idx * 0.1 }}
                className="group bg-white rounded-xl border-2 border-slate-200 hover:border-sky-300 hover:shadow-lg transition-all p-5 text-center cursor-pointer h-full"
              >
                <div className={`w-14 h-14 mx-auto rounded-xl bg-gradient-to-br ${persona.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg`}>
                  <persona.icon className="w-7 h-7 text-white" />
                </div>
                <h4 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-sky-600 transition-colors">{persona.title}</h4>
                <p className="text-xs text-gray-600 mb-2">{persona.tagline}</p>
                <div className="flex items-center justify-center text-sky-600 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn more <ArrowRight className="w-3 h-3 ml-1" />
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PersonaNavigation;
